import http from '../../../plugins/axios';

export default {
    getIncubatorList(data) {
        return http.get({
            url: '/admin/incubator/listByPage',
            data
        })
    },
    getIncubatorOrderListByPage(data) {
        return http.get({
            url: '/admin/incubator/order/listByPage',
            data
        })
    },
    getIncubatorDetail(data) {
        return http.get({
            url: '/admin/incubator/detail',
            data
        })
    },
    getIncubatorDataView(data) {
        return http.get({
            url: '/admin/incubator/dataView',
            data,
            cover: false
        })
    },
    getIssueTokensInfo(data) {
        return http.get({
            url: '/admin/incubator/issue/info',
            data
        })
    },
    getAllSupportingPairs(data) {
        return http.get({
            url: '/admin/incubator/all/pair',
            data
        })
    },
    getAllCountry(data) {
        return http.get({
            url: '/admin/incubator/all/country',
            data
        })
    },
    getAllChain(data) {
        return http.get({
            url: '/admin/incubator/all/getAllChain',
            data
        })
    },
    addOrUpdateIncubator(data) {
        return http.post({
            url: `/admin/incubator/addOrUpdate`,
            data
        });
    },
    deleteIncubator(data) {
        return http.post({
            url: `/admin/incubator/logic/delete`,
            data,
            dataType: 'form'
        });
    },
    updateOnline(data) {
        return http.post({
            url: `/admin/incubator/online`,
            data,
            dataType: 'form'
        });
    },
    platformSnapUp(data) {
        return http.post({
            url: `/admin/incubator/platformSnapUp`,
            data,
            dataType: 'form'
        });
    },
    platformWaterFlooding(data) {
        return http.post({
            url: `/admin/incubator/platformWaterFlooding`,
            data,
            dataType: 'form'
        });
    },
    checkIncubator(data) {
        return http.post({
            url: `/admin/incubator/check`,
            data,
            dataType: 'form'
        });
    },
    calculationIncubator(data) {
        return http.post({
            url: `/admin/incubator/calculation`,
            data,
            dataType: 'form'
        });
    },
    issueTokens(data) {
        return http.post({
            url: `/admin/incubator/issueTokens`,
            data,
            dataType: 'form'
        });
    },

    getAllSupportCoin() {
        return http.get({
            url: '/admin/coin/allDisplay'
        });
    },
    exportIncubatorOrderRecord(data) {
        return http.post({
            url: '/admin/incubator/order/export',
            data,
            dataType: 'form',
            responseType: 'blob',
            headers: {
                'Content-Type': 'application/json'
            }
        })
    },
}
